module.exports = __webpack_public_path__ + "img/barley.png";